import {Injectable} from '@angular/core'

/**
 * One entry in the left sidebar.
 *
 * Same shape as Juno's `SideBarItem` (projects/juno/.../sidebar.service.ts)
 * on purpose: the two internal apps sit in one workspace and a tester moves
 * between them, so the nav should not need re-learning. `googleIcon` is a
 * Material Symbols Outlined ligature name.
 */
export interface SideBarItem {
  id: string
  name: string
  path: string
  googleIcon: string
  selected: boolean
}

/**
 * Argus's nav.
 *
 * TWO JOBS, so two items. The inbox answers "what did the platform send this
 * phone?" — merged from identity's OTP simulation and mercury's own inbox
 * (docs/task-merge-identity-sms-inbox.md). The booking console answers "does
 * chronos still obey the assignment rules?".
 *
 * They are listed in the order a tester uses them: run the booking suite, then
 * read what it provoked. The turn demo is the third job: not a test but a
 * stage — a support engineer books rapidly here while the audience watches the
 * venus calendar and turn tracker distribute the work. Deliberately FLAT —
 * grouping three items is structure ahead of need, and Juno stayed flat
 * to seven.
 */
const SIDE_BAR_ITEMS: SideBarItem[] = [
  {
    id: 'inbox',
    name: 'Message Inbox',
    path: '/customers',
    googleIcon: 'mark_email_unread',
    selected: false,
  },
  {
    id: 'booking-tests',
    name: 'Booking Tests',
    path: '/booking-tests',
    googleIcon: 'science',
    selected: false,
  },
  {
    id: 'turn-demo',
    name: 'Turn Demo',
    path: '/turn-demo',
    googleIcon: 'insights',
    selected: false,
  },
]

@Injectable({providedIn: 'root'})
export class SidebarService {
  /** A fresh copy per caller — `selected` is per-view state, not shared truth. */
  getSideBarItems(): SideBarItem[] {
    return SIDE_BAR_ITEMS.map((item) => ({...item}))
  }
}
